require('./libs/cssua.min.js');
require('./libs/velocity.min.js');
//require('./libs/slick.min.js');
require('./main.js'); //中でjqueryを読む
